import { render } from "./TransactionOverviewTables.vue?vue&type=template&id=ae32c136&scoped=true"
import script from "./TransactionOverviewTables.vue?vue&type=script&lang=js"
export * from "./TransactionOverviewTables.vue?vue&type=script&lang=js"

import "./TransactionOverviewTables.vue?vue&type=style&index=0&id=ae32c136&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae32c136"]])

export default __exports__